type Props = {
  title: string;
  content: string | React.ReactNode;
  closeAlert?: Function;
  alertImportance?: "high" | "medium" | "low" | "agent" | "retention";
};

export const Alert: React.FunctionComponent<Props> = ({ title, content, closeAlert, alertImportance = "high" }) => {
  const alertClass =
    alertImportance === "agent" || alertImportance === "retention"
      ? `alert--${alertImportance}`
      : `alert--${alertImportance}-importance`;

  return (
    <div className="alert" style={{ display: "flex", maxWidth: "100%" }}>
      <div className={alertClass}>
        <span
          className={
            alertImportance === "agent"
              ? "icon-help-center-agent"
              : alertImportance === "retention"
                ? "icon-loader-g"
                : "icon-info"
          }
        ></span>
        <ul className="alert-list">
          <li className="alert-content close-btn">
            {closeAlert && (
              <button aria-label="Close alert" className="icon-close-20" onClick={() => closeAlert()}></button>
            )}
            <h3 className="font--bold">{title}</h3>
            <p>{content}</p>
          </li>
        </ul>
      </div>
    </div>
  );
};